import type { JsonQuestionnaireSection } from './types';

/**
 * Reliable active-question count for list cards, triggered blocks, and detail headers.
 * Prefers flattened `questions[]`, then API count fields.
 */
export function getActiveQuestionCount(section: JsonQuestionnaireSection): number {
  const fromQuestions = (section.questions ?? []).filter((q) => q.isActive !== false).length;
  if (fromQuestions > 0) return fromQuestions;

  const customCount =
    typeof section.customQuestionsCount === 'number' && Number.isFinite(section.customQuestionsCount)
      ? section.customQuestionsCount
      : 0;

  if (typeof section.templateQuestionsCount === 'number' && Number.isFinite(section.templateQuestionsCount)) {
    return section.templateQuestionsCount + customCount;
  }

  if (typeof section.questionsCount === 'number' && Number.isFinite(section.questionsCount)) {
    return section.questionsCount;
  }

  return 0;
}
